<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <div class="row pl-4 pr-4" v-show="tela == 1">
            <h4 slot="header" class="card-title text-left m-0">
              RELATÓRIO ANALÍTICO DE PONTO
            </h4>
            <BaseFiltroRelatorio
              class="col-sm-6 col-12"
              @pesquisar="pesquisar"
              @enviarEmail="enviarEmail"
              :isMessage="false"
            />
            <div class="offset-sm-6 "></div>
          </div>

          <div class="row pl-4 pr-4" v-show="tela == 2" id="imprimirFolha">
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class="col-6 d-flex justify-content-start hidden-print">
                <base-button
                  v-show="!printing"
                  type="info"
                  class="animation-on-hover"
                  @click="tela = 1"
                  ><i class="tim-icons icon-minimal-left"></i>
                  Voltar</base-button
                >
              </div>
              <div class="col-6 d-flex justify-content-end hidden-print">
                <base-button
                  v-show="!printing"
                  type="info"
                  class="animation-on-hover"
                  @click="imprimirFolha()"
                  simple
                >
                  <i class="tim-icons icon-paper"></i> Imprimir
                </base-button>
              </div>
            </div>

            <!--Cabecalho-->
            <div class="container p-3 rounded" style="background: #f9f9f9;">
              <div class="row">
                <div class="col-6">
                  <div class="row">
                    <div class="col text-left">
                      {{ `RELATÓRIO ANALÍTICO DE PONTO` }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col text-left">
                      {{
                        `PERÍODO: ${moment(payloadPesquisa.data_inicial).format(
                          "DD/MM/YYYY",
                        )} à
                                            ${moment(
                                              payloadPesquisa.data_final,
                                            ).format("DD/MM/YYYY")}`
                      }}
                    </div>
                  </div>

                  <div class="row">
                    <div
                      class="col text-left"
                      v-if="!payloadPesquisa.id_funcionario"
                    >
                      {{
                        `DEPARTAMENTO: ${
                          payloadPesquisa.departamento
                            ? payloadPesquisa.departamento.descricao
                            : "TODOS"
                        }`
                      }}
                    </div>
                    <div class="col text-left" v-else>
                      {{ `DEPARTAMENTO: NENHUM` }}
                    </div>
                  </div>
                  <div class="row">
                    <div
                      class="col text-left"
                      v-if="!payloadPesquisa.id_funcionario"
                    >
                      {{
                        `POSTO DE TRABALHO: ${
                          payloadPesquisa.posto
                            ? payloadPesquisa.posto.local
                            : "TODOS"
                        }`
                      }}
                    </div>
                    <div class="col text-left" v-else>
                      {{ `POSTO DE TRABALHO: NENHUM` }}
                    </div>
                  </div>
                  <!-- <div class="row">
                    <div class="col text-left">
                      {{ `TOTAL DE FUNCIONÁRIOS ATIVOS: ${dados.length}` }}
                    </div>
                  </div> -->

                  <div class="row">
                    <div class="col text-left">
                      {{
                        `RELATÓRIO GERADO EM: ${moment().format(
                          "DD/MM/YYYY HH:mm",
                        )}`
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--Tabela de Resultados-->
            <div class="table-responsive p-3">
              <table class="table table-hover table-bordered">
                <thead>
                  <tr>
                    <th scope="col">Dia</th>
                    <th scope="col">Nome</th>
                    <th scope="col">Departamento</th>
                    <th scope="col">Ent1</th>
                    <th scope="col">Saí1</th>
                    <th scope="col">Ent2</th>
                    <th scope="col">Saí2</th>
                    <th v-if="mostrarColunaBatida(dados)" scope="col">Ent3</th>
                    <th v-if="mostrarColunaBatida(dados)" scope="col">Saí3</th>
                    <th v-if="mostrarColunaBatida(dados)" scope="col">Ent4</th>
                    <th v-if="mostrarColunaBatida(dados)" scope="col">Saí4</th>
                    <th scope="col">Trabalhadas</th>
                    <th scope="col">Atrasos</th>
                    <th scope="col">Extras 50%</th>
                    <th scope="col">Extras 100%</th>
                    <th scope="col">Faltas</th>
                    <th scope="col">Abonos</th>
                    <th scope="col">Tipo de Abonos Concedidos</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in dados" :key="item.id">
                    <th>
                      <p class="m-0 p-0">{{ item.data }}</p>
                    </th>
                    <th>
                      <p class="m-0 p-0">{{ item.nome }}</p>
                    </th>
                    <th>
                      <p class="m-0 p-0">{{ item.departamento }}</p>
                    </th>
                    <th>
                      <p class="m-0 p-0">
                        {{
                          item.batidas.length >= 1
                            ? moment(item.batidas[0]).format("HH:mm")
                            : ""
                        }}
                      </p>
                    </th>
                    <th>
                      <p class="m-0 p-0">
                        {{
                          item.batidas.length >= 2
                            ? moment(item.batidas[1]).format("HH:mm")
                            : ""
                        }}
                      </p>
                    </th>
                    <th>
                      <p class="m-0 p-0">
                        {{
                          item.batidas.length >= 3
                            ? moment(item.batidas[2]).format("HH:mm")
                            : ""
                        }}
                      </p>
                    </th>
                    <th>
                      <p class="m-0 p-0">
                        {{
                          item.batidas.length >= 4
                            ? moment(item.batidas[3]).format("HH:mm")
                            : ""
                        }}
                      </p>
                    </th>
                    <th v-if="mostrarColunaBatida(dados)">
                      <p class="m-0 p-0">
                        {{
                          item.batidas.length >= 5
                            ? moment(item.batidas[4]).format("HH:mm")
                            : ""
                        }}
                      </p>
                    </th>
                    <th v-if="mostrarColunaBatida(dados)">
                      <p class="m-0 p-0">
                        {{
                          item.batidas.length >= 6
                            ? moment(item.batidas[5]).format("HH:mm")
                            : ""
                        }}
                      </p>
                    </th>
                    <th v-if="mostrarColunaBatida(dados)">
                      <p class="m-0 p-0">
                        {{
                          item.batidas.length >= 7
                            ? moment(item.batidas[6]).format("HH:mm")
                            : ""
                        }}
                      </p>
                    </th>
                    <th v-if="mostrarColunaBatida(dados)">
                      <p class="m-0 p-0">
                        {{
                          item.batidas.length >= 8
                            ? moment(item.batidas[7]).format("HH:mm")
                            : ""
                        }}
                      </p>
                    </th>
                    <th>
                      <p class="m-0 p-0">{{ item.exercidas }}</p>
                    </th>
                    <th>
                      <p class="m-0 p-0">{{ item.atrasos }}</p>
                    </th>
                    <th>
                      <p class="m-0 p-0">{{ item.extras }}</p>
                    </th>
                    <th>
                      <p class="m-0 p-0">{{ item.extras100 }}</p>
                    </th>
                    <th>
                      <p class="m-0 p-0">{{ item.faltasDias }}</p>
                    </th>
                    <th>
                      <p class="m-0 p-0">{{ item.abonos }}</p>
                    </th>
                    <th>
                      <p class="m-0 p-0">{{ item.tipoAbonos }}</p>
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
            <!--Paginação-->
            <Paginacao
              v-show="!printing"
              :currentPage="pagination.currentPage"
              :totalPages="pagination.totalPages"
              @page-changed="listarRelatorioAnalitico"
            />
          </div>
        </card>
      </div>
    </div>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      >
      </loading>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { Card, BaseFiltroRelatorio, Paginacao } from "@/components/index";
import { Table, TableColumn, Select, Option } from "element-ui";
import swal from "sweetalert2";
import moment from "moment";
import axios from "axios"; // Certifique-se de importar axios para chamadas HTTP

export default {
  components: {
    Card,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BaseFiltroRelatorio,
    Paginacao,
  },
  data() {
    return {
      payloadPesquisa: Object,
      printing: false,
      isLoading: false,
      tela: 1, //1 filtros, 2 -resultados
      dados: [],
      pagination: {
        currentPage: 1,
        perPage: 20,
        totalItems: 0,
        totalPages: 0,
      },
    };
  },
  methods: {
    mostrarColunaBatida(data) {
      let resultado = false;

      for (const element of data) {
        if (element.batidas.length >= 5) {
          resultado = true;
        }
      }
      return resultado;
    },
    moment: function(data) {
      return moment(data);
    },
    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },
    carregarRelatorio(payload) {
      let th = this;
      th.isLoading = true;
      this.axios
        .post("/api/relatorio/relatorioAnalitico", payload, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          if (response.data.status) {
            th.showSwal(
              "auto-close",
              "Sucesso",
              "Solicitação enviada com sucesso! Os dados serão enviados para o(s) email(s) inserido(s)",
              "success",
            );
            setTimeout(() => {
              location.reload();
            }, 3000);
          } else {
            th.showSwal(
              "auto-close",
              "Erro",
              "Erro ao solicitar relatório!",
              "error",
            );
          }
        })
        .catch((err) => {
          th.isLoading = false;
          console.log(err);
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao solicitar relatório!",
            "error",
          );
        });
    },
    enviarEmail(event) {
      this.carregarRelatorio(event);
    },
    async pesquisar(event) {
      this.payloadPesquisa = event;
      this.listarRelatorioAnalitico(1);
    },
    async listarRelatorioAnalitico(page = 1) {
      this.isLoading = true;
      const payload = {
        ...this.payloadPesquisa,
        page,
        tipo: this.filtro,
        limit: this.pagination.perPage,
      };
      this.payloadPesquisa = payload;

      try {
        const response = await axios.post(
          "/api/relatorio/relatorioAnalitico",
          payload,
          {
            headers: {
              "id-actor": this.$cookies.get("id_actor"),
              "tipo-actor": this.$cookies.get("tipo_actor"),
            },
          },
        );
        if (response.data.status) {
          this.pagination = response.data.data.pagination;
          this.dados = response.data.data.dados;
          this.tela = 2;
        }
      } catch (error) {
        swal.fire("Erro", "Erro ao buscar dados do relatório.", "error");
      } finally {
        this.isLoading = false;
      }
    },
    imprimirFolha() {
      this.printing = true;
      this.isLoading = true;

      try {
        this.$nextTick(() => {
          this.$htmlToPaper("imprimirFolha", null, () => {
            this.printing = false;
            this.isLoading = false;
          });
        });
      } catch (error) {
        console.error("Erro ao imprimir a folha:", error);
        this.isLoading = false;
        this.printing = false;
      }
    },
  },
};
</script>
<style></style>
